import React, { Component } from 'react';
import ReactSVG from 'react-svg';
import { List } from 'src/components/list/List';
import { Synapses } from 'src/components/synapses/Synapses';
import { wobblyLineProps } from 'src/pages/slide';
import { inViewService } from 'src/services/InViewService';
import { BlobFiller } from '../../../components/blob-filler/BlobFiller';
import brainAnchors from './anchor-data/brain';
import './WhySlide2.scss';

export class WhySlide2 extends Component {

  constructor(props) {
    super(props);

    this.state = {
      brainIsInView: false
    }
  }

  componentDidMount() {
    inViewService.add({id: 'synapses', element: this.refs.brain, onScroll: brainIsInView => this.onScroll(brainIsInView)});
  }

  onScroll(brainIsInView) {
    this.setState({
      brainIsInView,
    });
  }

  componentWillUnmount() {
    inViewService.remove('synapses');
    this.refs.synapses.stop();
  }

  render() {
    return (
      <div className="WhySlide2" {...wobblyLineProps({ color: this.props.color })}>
        <div className="Page-slide">
          <div className="Page-content">
            <p>According to the World Economic Forum there are <b>10 skills</b> that are <b>crucial to success</b> in our ever-changing digitally-driven business environment:</p>
            <div className="WhySlide2-list">
              <List color="0xFFFFFF">
                <li>Complex Problem Solving</li>
                <li>Critical Thinking</li>
                <li>Creativity</li>
                <li>People Management</li>
                <li>Co-ordination with others</li>
                <li>Emotional Intelligence - Empathy</li>
                <li>Judgement and Decisions</li>
                <li>Service orientation</li>
                <li>Negotiations</li>
                <li>Cognitive Flexibility</li>
              </List>
            </div>
          </div>

          <div className="Page-image">
            <div className="Brain" ref="brain">
              <BlobFiller fill={{
                  anchors: brainAnchors,
                  x: 40,
                  y: 40,
                  color: 0xF05A7D,
                  wobbleVariation: { position: 10 },
                }}
                x={-40} y={-40}
                width={400} height={300}
                isInView={this.state.brainIsInView} />
              <Synapses brainFillPoints={brainAnchors} ref="synapses" isInView={this.state.brainIsInView} />
              <div className="Brain-outline">
                <ReactSVG src="./assets/why/brain-placeholder.svg" />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
